module.exports = __webpack_public_path__ + "img/user.4788048f.png";